import { render } from "./MessageChat.vue?vue&type=template&id=3fbbfd37&scoped=true"
import script from "./MessageChat.vue?vue&type=script&lang=js"
export * from "./MessageChat.vue?vue&type=script&lang=js"

import "./MessageChat.vue?vue&type=style&index=0&id=3fbbfd37&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbbfd37"]])

export default __exports__